var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('img',{class:_vm.$store.getters.hOrV + ' h350',attrs:{"src":_vm.panelImage,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }